import { api } from "./api";

/**
 * Forum API helpers (v79.181).
 *
 * Every endpoint is anonymous-tolerant so a locked-out user can still
 * report a sign-in bug. Signed-in requests automatically carry the JWT
 * via the shared axios instance so the backend surfaces name + avatar.
 */
export const forumApi = {
    list: (params = {}) => api.get("/forum/threads", { params }).then((r) => r.data),
    get: (id) => api.get(`/forum/threads/${id}`).then((r) => r.data),
    create: (payload) => api.post("/forum/threads", payload).then((r) => r.data),
    comment: (threadId, payload) =>
        api.post(`/forum/threads/${threadId}/comments`, payload).then((r) => r.data),
    markSolution: (threadId, commentId) =>
        api.post(`/forum/threads/${threadId}/mark-solution/${commentId}`).then((r) => r.data),
    close: (threadId) => api.post(`/forum/threads/${threadId}/close`).then((r) => r.data),
    reportThread: (threadId, reason) =>
        api.post(`/forum/threads/${threadId}/report`, { reason }).then((r) => r.data),
    reportComment: (commentId, reason) =>
        api.post(`/forum/comments/${commentId}/report`, { reason }).then((r) => r.data),
    quickSolutions: (limit = 6) =>
        api.get("/forum/quick-solutions", { params: { limit } }).then((r) => r.data),
};

export const FORUM_CATEGORIES = [
    { id: "sign-in-issue", label: "Sign-in issue", emoji: "🔐" },
    { id: "account",       label: "Account",       emoji: "👤" },
    { id: "bug",           label: "Bug",           emoji: "🐛" },
    { id: "posting-ads",   label: "Posting Ads",   emoji: "📝" },
    { id: "payments",      label: "Payments",      emoji: "💳" },
    { id: "shop-store",    label: "Digital Store", emoji: "🏬" },
    { id: "funboard",      label: "Funboard",      emoji: "🎉" },
    { id: "android-app",   label: "Android App",   emoji: "📱" },
    { id: "feedback",      label: "Feedback",      emoji: "💬" },
    { id: "other",         label: "Other",         emoji: "❓" },
];

export function forumCategoryLabel(id) {
    return FORUM_CATEGORIES.find((c) => c.id === id)?.label || "Other";
}
